function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}

function debounce(fn, delay = 300) {
  let t;
  return function(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), delay);
  };
}

function updateBrowserUrl(_url) {
	// Remove ajax parameter and any other unwanted params
	const cleanUrl = _url.replace(/&ajax=[^&]*/, '');

	// Create URL object for normalize
	const urlObj = new URL(cleanUrl, window.location.origin);

	// Sort query parameters for consistency
	const params = new URLSearchParams(urlObj.search);
	const sortedParams = new URLSearchParams();

	// Sort parameters alphabetically
	[...params.entries()].sort().forEach(([key, value]) => {
		sortedParams.append(key, value);
	});

	urlObj.search = sortedParams.toString();
	const normalizedUrl = urlObj.toString();

	const currentUrl = new URL(window.location.href);
	currentUrl.search = new URLSearchParams([...new URLSearchParams(currentUrl.search).entries()].sort());

	if (currentUrl.toString() !== normalizedUrl) {
		// Push a new history entry (clean URL without ajax)
		history.pushState({ ajax: true }, '', normalizedUrl);
	}

	var $textSearch = $("#search-text");
	if ($textSearch.length) {
		var containsTextUrlParam = getUrlParameter("fulltext");
		// Decode dan replace + dengan spasi untuk display di input field
		if (containsTextUrlParam) {
			containsTextUrlParam = containsTextUrlParam.replace(/\+/g, ' ');
		}
		$textSearch.val(containsTextUrlParam || '');
	}
}

  /********************************************/
  /* Build URL string from all search sources */
  /********************************************/
  function setQueryURL() {
    var viewModeParams =
      getUrlParameter("viewmode") === undefined ||
      getUrlParameter("viewmode") === ""
        ? ""
        : "viewmode=" + getUrlParameter("viewmode");

    if ($("#search-text").length > 0) {
      var $textSearch = $("#search-text");
      var containsTextUrlParam = getUrlParameter("fulltext");

      if (containsTextUrlParam !== undefined && containsTextUrlParam !== "") {
        if ($textSearch.val() == containsTextUrlParam) {
          var textSearch =
            $textSearch.data("paramkey") + "=" + encodeURIComponent(containsTextUrlParam);
        } else {
          var textSearch =
            $textSearch.val() == ""
              ? ""
              : $textSearch.data("paramkey") + "=" + encodeURIComponent($textSearch.val());
        }
      } else {
        var textSearch =
          $textSearch.val() == ""
            ? ""
            : $textSearch.data("paramkey") + "=" + encodeURIComponent($textSearch.val());
      }
    }
    var queryUrlParams =
      location.protocol + "//" + location.host + location.pathname + "?";
    if (textSearch != "" && textSearch !== undefined) {
      queryUrlParams += textSearch;
    }

    if (viewModeParams != "" && window["viewModeParamsSwitch"] == undefined) {
      if (queryUrlParams.slice(-1) != "?" && queryUrlParams.slice(-1) != "&") {
        queryUrlParams += "&";
      }
      queryUrlParams += viewModeParams;
    } else if (window["viewModeParamsSwitch"] != undefined) {
      if (queryUrlParams.slice(-1) != "?" && queryUrlParams.slice(-1) != "&") {
        queryUrlParams += "&";
      }
      queryUrlParams += window["viewModeParamsSwitch"];
    } else {
      if (queryUrlParams.slice(-1) != "?" && queryUrlParams.slice(-1) != "&") {
        queryUrlParams += "&";
      }
      queryUrlParams += "viewmode=list";
    }

    $.each($(".filter__checkbox"), function () {
      var checkboxKey = $(this).data("paramkey");
      var checkboxParams = checkboxKey + "=" + window[checkboxKey + "Params"];

      if ($(this).find("input[type=checkbox]:checked").length > 0) {
        if (
          window[checkboxKey + "Params"] != "" ||
          window[checkboxKey + "Params"] != undefined
        ) {
          if (
            queryUrlParams.slice(-1) != "?" &&
            queryUrlParams.slice(-1) != "&"
          ) {
            queryUrlParams += "&";
          }
          queryUrlParams += checkboxParams;
        }
      }
    });

    if ($(".filter__status__checkbox").length > 0) {
      var checkboxKey_status = $(".filter__status__checkbox").data("paramkey");
      var checkboxParams_status =
        checkboxKey_status + "=" + window[checkboxKey_status + "Params"];

      if (
        $(".filter__status__checkbox").find("input[type=checkbox]:checked")
          .length > 0
      ) {
        if (
          window[checkboxKey_status + "Params"] != "" ||
          window[checkboxKey_status + "Params"] != undefined
        ) {
          if (
            queryUrlParams.slice(-1) != "?" &&
            queryUrlParams.slice(-1) != "&"
          ) {
            queryUrlParams += "&";
          }
          queryUrlParams += checkboxParams_status;
        }
      }
    }
    return queryUrlParams;
  }
  
  // Optional: abort any in-flight request to prevent stale overwrites
  let activeXhr = null;

  const debouncedGet = debounce(function (url, onSuccess) {
    // Start loader here if you prefer to show it only for the final call
    // $loader.removeClass("d-none").show();

    if (activeXhr && activeXhr.readyState !== 4) {
      try { activeXhr.abort(); } catch (e) {}
    }
    activeXhr = $.get(url, onSuccess);
  }, 400);

  // FILTERING
  // target --> Where to put the result
  function filter(target, parent, callbacks, options = {}) {
    var $loader = $(".ajax-loader--filtering");
    var $noResult = target.attr("data-noresults");

    // Hide target element before processing
    target.animate({ opacity: 0 }, 10, function () {
      $loader.removeClass("d-none");
      $loader.show();
    });

    // Building the AJAX URL
    var _url = setQueryURL();

    // Update form action
    if (parent.attr("data-url") != "" && parent.attr("data-url") != undefined) {
      var landingPageUrl = parent.attr("data-url");

      let lastItem = _url.substring(_url.lastIndexOf("?") + 1)
      if (_url.includes('?') && landingPageUrl.substr(1, 2) === _url.substr(_url.lastIndexOf("/") + 1, 2)) {
        lastItem = lastItem.startsWith('?') ? lastItem : ('?' + lastItem);
      } else {
        lastItem = _url.substring(_url.lastIndexOf("/") + 1);
      }

      _url =
        location.protocol + "//" + location.host + landingPageUrl + lastItem;
    }
    
    // Normalize &amp; → &
    _url = _url.replace(/&amp;/g, '&');

    // Update browser URL with query string (without ajax)
    updateBrowserUrl(_url);

    parent.attr("action", _url);

    // Update back to bottom button
    $(".back-to-bottom a").attr("data-url", _url + "&page_size=10000");


    // Build ajax URL safely
    const ajaxUrl = _url + (_url.includes('?') ? '&' : '?') + 'ajax=1';
    const url = options.ajaxUrl || ajaxUrl; // fallback to ajaxUrl we built here

    // Debounced GET: last call only
    debouncedGet(url, function (data) {
      var $data = $(data);
      var $result = $data.find("#results");

      // Update output
      if ($result.find(".results__row").children().length > 0) {
        target.html($result.html());
      } else {
        target
          .find(".results__row")
          .html('<div class="no-result">' + $noResult + '</div>');
        target.find(".filters-number").remove();
      }

      // Unhide the result
      target.animate({ opacity: 1 }, 10);

      $loader.hide();
      $loader.addClass("d-none");
    });

    return url
  }

$(function () {
  // View Mode
  var viewmode =
    getUrlParameter("viewmode") === undefined ||
    getUrlParameter("viewmode") === ""
      ? ""
      : getUrlParameter("viewmode");
  $("body").on("click", ".btn--switch", function (e) {
    e.preventDefault();
    var paramkey = $(this).data("paramkey");
    var mode = $(this).data("mode");
    window["viewModeParamsSwitch"] = "viewmode=" + mode;

    var _url = setQueryURL();
    var target = $("#results");
    var $noResult = target.attr("data-noresults");

    $.get(_url + "&ajax=", function (data) {
      var $data = $(data);
      var $result = $data.find("#results");

      // Update output
      if ($result.find(".results__row").children().length > 0) {
        target.html($result.html());
      } else {
        target
          .find(".results__row")
          .html('<div class="no-result">' + $noResult + "</div>");
        target.find(".switch-view").html($result.find(".switch-view"));
        target.find(".filters-number").remove();
      }

      if (mode == "map") {
        $("#site-footer div[data-os-animation]").each(function () {
          var osElement = $(this),
            osAnimationClass = osElement.attr("data-os-animation");
          osElement.addClass("animate__animated").addClass(osAnimationClass);
        });
      }

      // Unhide the result
      target.animate({ opacity: 1 }, 10);
    });
  });

  // Search text input value
  if ($("#search-text").length > 0) {
    var $textSearch = $("#search-text");

    // Put the value from URL if exists
    var containsTextUrlParam = getUrlParameter("fulltext");
    if (containsTextUrlParam !== undefined && containsTextUrlParam !== "") {
      $textSearch.val(containsTextUrlParam.replace(/\+/g, ' '));
    }

    // Input text keyup event
	$textSearch.on("keyup", function (ev) {
	  var $this = $(this);
	  var pressed = ev.which || ev.keyCode;
	  
	  if (pressed === 13) return;
	  
	  var value = $this.val().trim();
	  var words = value.split(/\s+/);
	  var hasValidWord = words.some(w => w.length >= 3);
	  
	  if (
		(pressed != 8 &&
		  (hasValidWord || $this.val().length == 0)) ||
		pressed == 8
	  ) {
		// Call the filter fct
		if (viewmode === "map" || $("#the-map").length > 0) {
		  // Refresh Map Marker
		  RefreshMarkers($this.parents("form"));
		} else {
		  // Launches the filter function
		  filter($("#results"), $this.parents("form"));
		}
	  }

	  if (
		(hasValidWord ||
		  $(".box__search__filters__items ul li").length > 0 ||
		  $(".box__search__status .form-check-input:checked").length > 0) &&
		($this.parents("form").attr("data-url") == "" ||
		  $this.parents("form").attr("data-url") == undefined)
	  ) {
		$(".box__search__filters").removeClass("d-none");
	  } else {
		$(".box__search__filters").addClass("d-none");
	  }
	});

	$textSearch.on("keypress", function (ev) {
	  if (ev.key === "Enter" || ev.keyCode === 13) {
		ev.preventDefault();
		
		const isMobile = (
		  /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
		  window.innerWidth <= 768
		);
		
		if(isMobile) {
		  $textSearch.blur();
		}
		
		if (window.location.pathname === '/') {
		  const currentUrl = new URL(window.location);
		  window.location = `/outils?fulltext=${encodeURIComponent($textSearch.val())}&viewmode=list`;
		} else {
		  const ajaxUrl = location.href + (location.href.includes('?') ? '&' : '?') + 'ajax=1';
		  filter($("#results"), $textSearch.parents("form"), null, { ajaxUrl: ajaxUrl });
		}
	  }
	});
  }

  // Filter checkbox
  $.each($(".filter__checkbox"), function () {
    var $checkbox = $(this);
    var checkboxKey = $checkbox.data("paramkey");
    window[checkboxKey + "Params"] = "";

    var checkboxURLParams =
      getUrlParameter(checkboxKey) === undefined ||
      getUrlParameter(checkboxKey) === ""
        ? ""
        : getUrlParameter(checkboxKey).replace(/§/g, "~§").substr(1).split("~");

    window[checkboxKey + "Params"] =
      checkboxURLParams === undefined || checkboxURLParams === ""
        ? ""
        : getUrlParameter(checkboxKey); // will gather all params and values

    if (checkboxURLParams) {
      $.each($checkbox.find("input[type=checkbox]"), function () {
        var val = $(this).val();

        if (jQuery.inArray(val, checkboxURLParams) != -1) {
          $(this).trigger("click");
        }
      });
    }

    $checkbox.find("input").click(function (e) {
      var checkboxVal = "";

      $.each($checkbox.find("input[type=checkbox]:checked"), function () {
        checkboxVal += $(this).val();
      });

      window[checkboxKey + "Params"] =
        checkboxVal == "" ? "" : checkboxVal.toString().replace(/,/g, "");

      // Launches the filter function
      if (viewmode === "map" || $("#the-map").length > 0) {
        // Refresh Map Marker
        RefreshMarkers($(this).parents("form"));
      } else {
        // Launches the filter function
        filter($("#results"), $(this).parents("form"));
      }
    });
  });

  // Filter status checkbox
  if ($(".filter__status__checkbox").length > 0) {
    var $checkbox_status = $(".filter__status__checkbox");
    var checkboxKey_status = $checkbox_status.data("paramkey");
    window[checkboxKey_status + "Params"] = "";

    var checkboxURLParams_status =
      getUrlParameter(checkboxKey_status) === undefined ||
      getUrlParameter(checkboxKey_status) === ""
        ? ""
        : getUrlParameter(checkboxKey_status)
            .replace(/§/g, "~§")
            .substr(1)
            .split("~");

    window[checkboxKey_status + "Params"] =
      checkboxURLParams_status === undefined || checkboxURLParams_status === ""
        ? ""
        : getUrlParameter(checkboxKey_status); // will gather all params and values

    $("body").on("click", ".filter__status__checkbox input", function () {
      var checkboxVal_status = "";

      $.each(
        $(this)
          .parents(".filter__status__checkbox")
          .find("input[type=checkbox]:checked"),
        function () {
          checkboxVal_status += $(this).val();
        }
      );

      window[checkboxKey_status + "Params"] =
        checkboxVal_status == ""
          ? ""
          : checkboxVal_status.toString().replace(/,/g, "");

      // Launches the filter function
      if (viewmode === "map" || $("#the-map").length > 0) {
        // Refresh Map Marker
        RefreshMarkers($(".box__search--initiatives form"));
      } else {
        // Launches the filter function
        filter($("#results"), $(".box__search--initiatives form"));
      }
    });
  }

  if ($("#results .results__row").children().length == 0) {
    $("section:not(.search) #results .results__row").html(
      '<div class="no-result">' +
        $("#results").attr("data-noresults") +
        "</div>"
    );
    $("section:not(.search) #results").find(".filters-number").remove();
    $("section.search #results").html('<div class="no-result"></div>');
  }

  // Pager
  $("body").on("click", ".pager button:not(:disabled)", function (e) {
    var $indexPage = $(this).attr("data-pageindex");
    var _url = setQueryURL();

    const dataUrl = _url + "&pageindex=" + $indexPage;

    $(this).attr("data-url", dataUrl);

    const url = new URL(window.location.href);
    url.searchParams.set('pageindex', $indexPage); // Update or add 'pageindex=3'

    history.pushState({ ajax: true }, '', url);

    pager(
      $(this),
      "#results",
      $("#results .results__row .results__content .result__card"),
      $(this).parents(".pager")
    );
  });


  // Create Map Marker
  function RefreshMarkers(parent) {
    // Building the AJAX URL
    var _url = setQueryURL();

    // Update form action
    if (parent != undefined) {
      if (
        parent.attr("data-url") != "" &&
        parent.attr("data-url") != undefined
      ) {
        var landingPageUrl = parent.attr("data-url");
        var lastItem = _url.substring(_url.lastIndexOf("/") + 1);

        _url =
          location.protocol + "//" + location.host + landingPageUrl + lastItem;
      }
      parent.attr("action", _url);
    }
	
    updateBrowserUrl(_url);
	
    $.get(_url + "&ajax=", function (data) {
      var $data = $(data);
      var $mapData = $data.find("#the-map");
      var $marker = $data.find("#markers");
      var $notFound = $data.find(".no-result");
      var $resultNumber = $data.find(".result-number");

      if ($mapData.length == 0) {
        $("#results")
          .find(".results__row")
          .html(
            '<div class="no-result">' +
              $("#results").attr("data-noresults") +
              "</div>"
          );
        $("#results").find(".filters-number").remove();
      } else {
        $("#results").html($data.find("#results").html());
        $(".result-number").html($resultNumber.html());
      }
    });
  }

  //Pager
  function pager(loaderTarget, ajaxTarget, htmlTarget, pagerTarget) {
    var $loaderTarget = loaderTarget;
    var $ajaxTarget = ajaxTarget;
    var $htmlTarget = htmlTarget;
    var $pagerTarget = pagerTarget;
    var $loader = $(".ajax-loader--filtering");

    $nextPageUrl = $loaderTarget.attr("data-url");

    // Hide target element before processing
    $($ajaxTarget).animate({ opacity: 0 }, 10, function () {
      $loader.removeClass("d-none");
      $loader.show();
    });

    $.get($nextPageUrl, function (data) {
      $data = $(data).find($ajaxTarget);
      $htmlTarget.html($data.find(".result__card > article"));
      $pagerTarget.html($data.find(".pager > ul"));

      // Unhide the result
      $($ajaxTarget).animate({ opacity: 1 }, 10);

      $loader.hide();
      $loader.addClass("d-none");
    }).done(function () {
      setTimeout(function () {
        $("html,body").animate(
          { scrollTop: $($ajaxTarget).offset().top },
          "slow"
        );
      }, 1000);
    });
  }
  
  
});

window.filter = filter;